import { VideoAdsQuizBody } from "./components/video-ads-quiz-body/video-ads-quiz-body.component";
import { VideoAdsQuizFooter } from "./components/video-ads-quiz-footer/video-ads-quiz-footer.component";
import { VideoAdsQuizHeader } from "./components/video-ads-quiz-header/video-ads-quiz-header.component";

export function VideoAdsQuizWidget() {
  return (
    <>
      <VideoAdsQuizHeader />
      <VideoAdsQuizBody />
      <VideoAdsQuizFooter />
    </>
  );
}
